var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCargoalone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 94,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 862,
    y: 226,
    width: 86,
    height: 94
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-862 -226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.01468 51.0587 42.4475 25.11",
    stroke: "#B3B3B3",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3638 21.1865C34.3638 24.7988 37.3605 27.7075 40.9999 27.5723 44.2874 27.4505 47.0135 24.7244 47.1353 21.4368 47.2097 19.536 46.4521 17.811 45.1939 16.5934 42.4542 13.9417 40.7496 10.3971 40.7496 6.58189L40.7496 5.94603",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.372 1.01468 34.1406 1.01468 35.7032 5.93926 45.8094 5.93926 47.372 1.01468Z",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4475 25.11 83.8802 51.0587",
    stroke: "#B3B3B3",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01468 51.0587 83.8802 51.0587 83.8802 92.9786 1.01468 92.9786Z",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33391 56.8086 8.33391 86.0855",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.537 56.8086 14.537 86.0855",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7401 56.8086 20.7401 86.0855",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9431 56.8086 26.9431 86.0855",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1462 56.8086 33.1462 86.0855",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3493 56.8086 39.3493 86.0855",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5456 56.8086 45.5456 86.0855",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7487 56.8086 51.7487 86.0855",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9518 56.8086 57.9518 86.0855",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1549 56.8086 64.1549 86.0855",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3579 56.8086 70.3579 86.0855",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5543 56.8086 76.5543 86.0855",
    stroke: "#000000",
    strokeWidth: 2.02936,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    transform: "matrix(1.00929 0 0 1 862.158 226)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoalone);
export default __webpack_public_path__ + "static/media/cargo alone.b29010327aade5b6effb71c6135cb2cc.svg";
export { ForwardRef as ReactComponent };